// extracted by mini-css-extract-plugin
export default {"page_wrapper":"group-activity-page_page_wrapper__+X9DV"};